import { render, staticRenderFns } from "./create_sub_org.vue?vue&type=template&id=6e690077&scoped=true&"
import script from "./create_sub_org.vue?vue&type=script&lang=js&"
export * from "./create_sub_org.vue?vue&type=script&lang=js&"
import style0 from "./create_sub_org.vue?vue&type=style&index=0&id=6e690077&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e690077",
  null
  
)

export default component.exports